import { ProductModel } from './product.model';

export class ProductCombinedModel extends ProductModel {
	availableForOneTimePurchase: boolean;
	availableForSubscription: boolean;
}
